import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type Status = 'opened' | 'closed'

interface ChatState {
  status: Status
  animate: boolean
  open(): void
  close(): void
  setStatus(status: Status): void
  setAnimate(animate: boolean): void
}

export const useChatStore = create<ChatState>()(
  devtools(
    (set) => ({
      status: 'closed',
      animate: false,
      open: () => {
        set(() => ({ status: 'opened' }), false, 'open')
      },
      close: () => {
        set(() => ({ status: 'closed' }), false, 'close')
      },
      setStatus: (status: Status) => set({ status }, false, 'setStatus'),
      setAnimate: (animate: boolean) => set({ animate }, false, 'setAnimate')
    }),
    { name: 'useChatStore' }
  )
)
